import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import { FaChevronDown, FaChevronUp, FaSoundcloud } from "react-icons/fa"
import { usePlayer } from "./PlayerContext"

const PersistentPlayer = () => {
  const { showPlayer, togglePlayerVisibility } = usePlayer()
  const iframeRef = useRef(null)

  useEffect(() => {
    // Only load iframe once
    if (iframeRef.current && iframeRef.current.src === "") {
      iframeRef.current.src =
        "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2104165098&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
    }
  }, [])

  return (
    <PlayerWrapper $visible={showPlayer}>
      <ToggleTab onClick={togglePlayerVisibility}>
        {showPlayer ? (
          <>
            <FaChevronDown />
            <span>Collapse Player</span>
          </>
        ) : (
          <>
            <FaSoundcloud />
            <span>Open Player</span>
          </>
        )}
      </ToggleTab>
      <div className="player-content">
        <iframe
          ref={iframeRef}
          title="Summer Breeze Mixtape 002"
          width="100%"
          height="100%"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2104165098&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
        />
      </div>
    </PlayerWrapper>
  )
}

const PlayerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: ${(props) => (props.$visible ? "100%" : "auto")};
  max-width: 400px;
  background: transparent;
  overflow: hidden;
  z-index: 10000;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  .player-content {
    width: ${(props) => (props.$visible ? "100%" : "auto")};
    height: ${(props) => (props.$visible ? "100%" : "0")};
    aspect-ratio: 1 / 1;
    overflow: hidden;
    transition: all 0.3s ease;
    opacity: ${(props) => (props.$visible ? "1" : "0")};
    visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
    pointer-events: ${(props) => (props.$visible ? "auto" : "none")};
    transition: all 0.3s ease;
  }

  @media (max-width: 768px) {
    width: ${(props) => (props.$visible ? "75vw" : "auto")};
    max-width: ${(props) => (props.$visible ? "75vw" : "auto")};

    .player-content {
      width: ${(props) => (props.$visible ? "75vw" : "auto")};
      aspect-ratio: 5 / 3;
    }
  }
`

const ToggleTab = styled.button`
  padding: 8px 16px;
  border-radius: 0 6px 0 0;
  border: none;
  background: var(--primary);
  color: #fff;
  cursor: pointer;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  span {
    margin-bottom: 2px;
  }
`

export default PersistentPlayer
